import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Ellipse = ({
  height = 16,
  width = 16,
  color = colors.grey35,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 3 4" fill="none" {...props}>
    <circle cx="1.5" cy="2" r="1.5" fill={getColor(color, isColorInherited)} />
  </SvgIcon>
);
